import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllJenisPembiayaanDokumenByJenisPembiayaanID = createAsyncThunk(
  "jenisPembiayaanDokumen/GetAllJenisPembiayaanDokumenByJenisPembiayaanID",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(
        `${api}master/jenis_pembiayaan_dokumen/get_by_jenis_pembiayaan_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

// TO FETCH ALL THE DOKUMEN | UPDATE HASIL REVISI
export const GetAllJenisPembiayaanDokumenUserByJenisPembiayaanID = createAsyncThunk(
  "jenisPembiayaanDokumen/GetAllJenisPembiayaanDokumenUserByJenisPembiayaanID",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(
        `${api}user/get_upload_file_user_pembiayaan/${data.id_jenis_pembiayaan}/${data.id_user}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllJenisPembiayaanDokumenDropdown = createAsyncThunk(
  "jenisPembiayaanDokumen/GetAllJenisPembiayaanDokumenDropdown",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}master/jenis_pembiayaan_dokumen`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllJenisPembiayaanDokumen = createAsyncThunk(
  "jenisPembiayaanDokumen/GetAllJenisPembiayaanDokumen",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}master/jenis_pembiayaan_dokumen/all?${data.url}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleJenisPembiayaanDokumen = createAsyncThunk(
  "jenisPembiayaanDokumen/GetSingleJenisPembiayaanDokumen",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/jenis_pembiayaan_dokumen/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const layananSlice = createSlice({
  name: "jenis_pembiayaan_dokumen",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all jenis pembiayaan dokumen by jenis pembiayaan
    builder.addCase(GetAllJenisPembiayaanDokumenByJenisPembiayaanID.pending, loadingHandler);
    builder.addCase(GetAllJenisPembiayaanDokumenByJenisPembiayaanID.fulfilled, fulfilledHandler);
    builder.addCase(GetAllJenisPembiayaanDokumenByJenisPembiayaanID.rejected, rejectedHandler);
    // get all jenis pembiayaan users dokumen by jenis pembiayaan
    builder.addCase(GetAllJenisPembiayaanDokumenUserByJenisPembiayaanID.pending, loadingHandler);
    builder.addCase(GetAllJenisPembiayaanDokumenUserByJenisPembiayaanID.fulfilled, fulfilledHandler);
    builder.addCase(GetAllJenisPembiayaanDokumenUserByJenisPembiayaanID.rejected, rejectedHandler);
    // get all jenis pembiayaan dokumen
    builder.addCase(GetAllJenisPembiayaanDokumenDropdown.pending, loadingHandler);
    builder.addCase(GetAllJenisPembiayaanDokumenDropdown.fulfilled, fulfilledHandler);
    builder.addCase(GetAllJenisPembiayaanDokumenDropdown.rejected, rejectedHandler);
    // get all jenis pembiayaan dokumen
    builder.addCase(GetAllJenisPembiayaanDokumen.pending, loadingHandler);
    builder.addCase(GetAllJenisPembiayaanDokumen.fulfilled, fulfilledHandler);
    builder.addCase(GetAllJenisPembiayaanDokumen.rejected, rejectedHandler);
    // get Single jenis pembiayaan dokumen
    builder.addCase(GetSingleJenisPembiayaanDokumen.pending, loadingHandler);
    builder.addCase(GetSingleJenisPembiayaanDokumen.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleJenisPembiayaanDokumen.rejected, rejectedHandler);
  },
});

export const { reset } = layananSlice.actions;
export default layananSlice.reducer;
